import { render } from "./PartnerUserCreate.vue?vue&type=template&id=487fc1c4"
import script from "./PartnerUserCreate.vue?vue&type=script&lang=js"
export * from "./PartnerUserCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__